import { create } from "zustand";

interface PaymentRequiredState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const usePaymentRequiredStore = create<PaymentRequiredState>(
  (set) => ({
    isOpen: false,
    open: () => { set({ isOpen: true }); },
    close: () => { set({ isOpen: false }); },
  }),
);
